import * as actions from '../actions'

var defaultState = null

export default function entity(state = defaultState, action) {
    switch (action.type) {

        case actions.ENTITY_GET_ONE:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.ENTITY_CLEAN_ONE:
            return defaultState

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/entity.js